import React, { useRef, useState } from "react";
import { IoMdCloudUpload } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
import apiService from "../services/apiService";
import bulkcsv from "../assets/csv_file/content.csv";
import { ToastContainer, toast } from "react-toastify";


function BulkUpload() {
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!selectedFile) {
            toast.error("Please select a file before uploading.");
            return;
        }
    
        setIsUploading(true);
        const formData = new FormData();
        const fileName = selectedFile.name.split(".")[0].toLowerCase();
    
        formData.append("file", selectedFile);
        formData.append("import_type", fileName);
    
        try {
            const response = await apiService.postData(
                "admin/upload-csv/validate",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
    
            if (response.message === "Please enter a valid Import Type.") {
                toast.error("The selected file is not valid.");
            } else if (response.code === 200 && response.data.rows) {
                toast.success("File uploaded successfully!");
    
                const payload = {
                    file: selectedFile,
                    fileName: fileName,
                    importType: fileName,
                    tableData: response.data.data || [],
                    apiResponse: response.data.rows,
                };
    
                navigate("/bulk_table", { state: { payload } });
            } else {
                toast.error("File upload failed.");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            const errorMsg = error.response?.data?.message || "An error occurred.";
            toast.error(`Upload failed: ${errorMsg}`);
        } finally {
            setIsUploading(false);
        }
    };
    

    return (
        <>
            <div className="container p-3">
      <ToastContainer />

                <h5 className="mb-0 text-dark">Bulk Upload</h5>

                <div className="card shadow-sm mt-3">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label fw-bold">Upload File</label>

                                <input
                                    type="file"
                                    className="file-input"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    hidden
                                />

                                <button
                                    className="upload-btn"
                                    type="button"
                                    onClick={handleUploadClick}
                                >
                                    <IoMdCloudUpload size={20} />
                                    <span>Select File</span>
                                </button>

                                {selectedFile && (
                                    <p className="file-name">Uploaded: {selectedFile.name}</p>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={!selectedFile || isUploading}
                            >
                                {isUploading ? "Uploading..." : "Save"}
                            </button>
                        </form>
                    </div>
                </div>
                <div
                    className="p-4 text-danger fw-bold card bg-light mt-3"
                    style={{ backgroundColor: "#fff", fontSize: "1.1rem" }}
                >
                    <div>
                        <p className="mb-0">
                            <strong>Download Sample: </strong>
                        </p>
                    </div>
                    <div className=" w-100" >
                        <div>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link active"
                                        id="content-tab"
                                        data-bs-toggle="tab"
                                        href="#content"
                                        role="tab"
                                        aria-controls="content"
                                        aria-selected="true"
                                    >
                                        Content
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link"
                                        id="chapters-tab"
                                        data-bs-toggle="tab"
                                        href="#chapters"
                                        role="tab"
                                        aria-controls="chapters"
                                        aria-selected="false"
                                    >
                                        Chapters
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link"
                                        id="characters-tab"
                                        data-bs-toggle="tab"
                                        href="#characters"
                                        role="tab"
                                        aria-controls="characters"
                                        aria-selected="false"
                                    >
                                        Characters
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content" id="myTabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="content"
                                    role="tabpanel"
                                    aria-labelledby="content-tab"
                                >
                                    <div className="card mt-3">
                                        <div className="card-body">
                                            <button
                                                className="btn btn-outline-primary me-2"
                                                onClick={() => {
                                                    const link = document.createElement("a");
                                                    link.href = "/csv_file/content.csv";
                                                    link.download = "content.csv";
                                                    link.click();
                                                }}
                                            >
                                                Download Content
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card shadow-sm mt-3">
                                        <div className="card-body">
                                            <h5>Sample File Admin</h5>
                                            <p>
                                                <strong>Product Code: </strong>
                                                <span className="text-danger">(compulsory)</span>
                                            </p>

                                            <h5 className="mt-4">Content</h5>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Title:</h6>
                                                    <p>Sample Title</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Description:</h6>
                                                    <p>Sample Description</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Duration in seconds:</h6>
                                                    <p>2</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Chapter Count:</h6>
                                                    <p>5</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Tags:</h6>
                                                    <p>Science, Learning</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>RFID:</h6>
                                                    <p>123456789</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Is Kids Favourite:</h6>
                                                    <p>Yes</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Is All-Time Classic:</h6>
                                                    <p>No</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* <div className="col-12 col-md-6">
                                                    <h6>Is Sleep:</h6>
                                                    <p>No</p>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="chapters"
                                    role="tabpanel"
                                    aria-labelledby="chapters-tab"
                                >
                                    <div className="card mt-3">
                                        <div className="card-body">
                                            <button
                                                className="btn btn-outline-primary me-2"
                                                onClick={() => {
                                                    const link = document.createElement("a");
                                                    link.href = "/csv_file/chapters.csv";
                                                    link.download = "chapters.csv";
                                                    link.click();
                                                }}
                                            >
                                                Download Chapters
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card shadow-sm mt-3">
                                        <div className="card-body">
                                            <h5>Sample File Admin</h5>
                                            <p>
                                                <strong>Product Code: </strong>
                                                <span className="text-danger">(compulsory)</span>
                                            </p>

                                            <h5 className="mt-4">Chapters</h5>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Content Title:</h6>
                                                    <p>Sample Content Title</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Title:</h6>
                                                    <p>Chapter 1</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {/* <div className="col-12 col-md-6">
                                                    <h6>Chapter Type:</h6>
                                                    <p>Lecture</p>
                                                </div> */}
                                                <div className="col-12 col-md-6">
                                                    <h6>Duration in seconds:</h6>
                                                    <p>30</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Song Number:</h6>
                                                    <p>1</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* <div className="col-12 col-md-6">
                                                    <h6>Duration in seconds:</h6>
                                                    <p>30</p>
                                                </div> */}
                                                {/* <div className="col-12 col-md-6">
                                                    <h6>audio_file:</h6>
                                                    <p>audio/01.mp3</p>
                                                </div> */}
                                            </div>
                                            {/* <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>audio_file:</h6>
                                                    <p>audio/01.mp3</p>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="characters"
                                    role="tabpanel"
                                    aria-labelledby="characters-tab"
                                >
                                    <div className="card mt-3">
                                        <div className="card-body">
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={() => {
                                                    const link = document.createElement("a");
                                                    link.href = "/csv_file/characters.csv";
                                                    link.download = "characters.csv";
                                                    link.click();
                                                }}
                                            >
                                                Download Characters
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card shadow-sm mt-3">
                                        <div className="card-body">
                                            <h5>Sample File Admin</h5>
                                            <p>
                                                <strong>Product Code: </strong>
                                                <span className="text-danger">(compulsory)</span>
                                            </p>

                                            <h5 className="mt-4">Characters</h5>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Content Title:</h6>
                                                    <p>Sample Content Title</p>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <h6>Name:</h6>
                                                    <p>John Doe</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <h6>Description:</h6>
                                                    <p>Main character in the story</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* <div
        className="text-muted p-3"
        style={{ fontSize: "1rem", background: "#fff" }}
      >
        &copy; 2025
        <Link to="/" className="text-decoration-none">
          <span className="text-danger"> Shambhavi Technovation</span>
        </Link>
      </div> */}

            <style>
                {`
        .file-upload-wrapper:hover {
          background-color: #e2e6ea;
        }

        .file-input {
          display: none;
        }

        .save_button {
          background-color: red;
          padding: 5px 25px;
          border-radius: 9px;
          color: white;
          transition: background 0.3s ease-in-out;
          border: 1px solid black;
          font-weight: bold;
        }

        .save_button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .save_button:hover:not(:disabled) {
          background-color: #28a745;  / ✅ Hover effect /
          color: #fff;
        }

        .upload-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          background-color: #007bff;
          color: white;
          border: none;
          padding: 10px 45px;
          border-radius: 5px;
          cursor: pointer;
          font-weight: bold;
          transition: background 0.3s ease-in-out;
        }

        .upload-btn:hover {
          background-color: #0056b3;
        }

        .file-name {
          margin: 0;
          font-size: 0.95rem;
          color: #28a745;
          font-weight: bold;
        }

        .sample-download {
          text-align: center;
          margin: 20px 0;
        }

        .download-link {
          text-decoration: none;
          font-weight: bold;
          color: red;
          font-size: 1.1rem;
        }

        .footer {
          text-align: center;
          font-size: 1rem;
          margin-top: 20px;
          padding: 10px;
          background: #fff;
        }

        .disabled-link {
          pointer-events: none;
          opacity: 0.5;
        }
        `}
            </style>
        </>
    );
}

export default BulkUpload;